import React, { useState } from 'react';

import Sidebar from '../../components/SideBar';
import Label from '../../components/Label';

import { Stepper, Step, StepLabel } from '@material-ui/core/';
import { toast } from 'react-toastify';

import Confirm from './Confirm';
import Event from './Event';
import Map from './Map';

import { Container } from './styles';

const CreateEvent = () => {
    const [activeStep, setActiveStep] = useState(0);
    const steps = [
        'Cadastre os dados do evento',
        'Defina todas as posições do evento',
        'Confirmação de dados'
    ];
    const [values, setValues] = useState({
        name: '',
        description: '',
        start_at: new Date(),
        finish_at: new Date(),
        start_hour: '',
        finish_hour: '',
        address: '',
        phone: null,
        cep: '',
        count_rows: 0,
        count_columns: 0,
        rows: [[]]
    });

    const nextStep = () => {
        console.log(values)
        if (
            !!values.name &&
            !!values.address &&
            !!values.cep && 
            !!values.count_rows &&
            !!values.count_columns &&
            !!values.phone &&
            !!values.start_hour &&
            !!values.finish_hour
        ) setActiveStep((prevActiveStep) => prevActiveStep + 1);
        else toast.warn("Necessário preencher todos os campos para continuar.")
    };

    const prevStep = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    function onChange(event) {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value });
    }

    const handleDateStartAt = (date) => { setValues({ ...values, start_at: date }) };
    const handleDateFinishAt = (date) => { setValues({ ...values, finish_at: date }) };

    function onChangeNumber(event) {
        const { valueAsNumber, name } = event.target;
        setValues({
            ...values,
            [name]: valueAsNumber,
            rows: Array(name === 'count_rows' ? valueAsNumber:values.count_rows)
                .fill()
                .map((u, index_i)=>Array(name === 'count_columns' ? valueAsNumber:values.count_columns)
                .fill()
                .map((u, index_j) => ({
                    id: index_j+1,
                    row: index_i,
                    col: index_j,
                    isReserved: false,
                    isSelected: false,
                    number: `${index_i}:${index_j}`,
                    name: `${index_i}:${index_j}`,
                })))
        });
    }

    function onChangeRow(row, col, item, val) {
        const data = values.rows
        data[row][col][item] = val;
        setValues({
            ...values,
            rows: data
        })
    }

    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return (<Event
                    nextStep={nextStep}
                    onChange={onChange}
                    onChangeNumber={onChangeNumber}
                    handleDateStartAt={handleDateStartAt}
                    handleDateFinishAt={handleDateFinishAt}
                    values={values}
                />)
            case 1:
                return (<Map
                    nextStep={nextStep}
                    prevStep={prevStep}
                    onChange={onChange}
                    onChangeRow={onChangeRow}
                    values={values}
                />);
            case 2:
                return (<Confirm
                    prevStep={prevStep}
                    values={values}
                />);
            default:
                (console.log('Finish steps'))
        }
    }

    const page = (
        <>
        <Label
            size='min'
            color='dark'
            align='left'
            weight='500'
        >
            Cadastrar novo evento
        </Label>
        <Container>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => {
                    return (<Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>)
                })}
            </Stepper>

            <div>
                <h1>{getStepContent(activeStep)}</h1>
            </div>
      </Container>
      </>
    )

    return ( <Sidebar current='Eventos' content={page}/> )
}

export default CreateEvent;
